import { useEffect, useState } from 'react';
import SearchService from '../../../service/search/Search';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../../context/ModalContext';
import { isLogin } from '../../../utils/auth';
import styled from 'styled-components';

export const MainPageTop = () => {
  const [showTooltip, setShowTooltip] = useState(true);

  const navigate = useNavigate();

  const handleClickUserButton = () => {
    if (!isLogin()) {
      navigate('/login');
    } else {
      navigate('/mypage');
    }
  };

  return (
    <Container>
      <Logo>
        <img
          src="/assets/images/logo/zipgoai_logo_mobile_header.svg"
          alt=""
          onClick={() => {
            navigate('/');
          }}
        />
      </Logo>
      <Content>
        <TicketButton onClick={() => navigate('/payment/plan')}>
          <ButtonLabel>결제 안내</ButtonLabel>
        </TicketButton>
        {!isLogin() && (
          <TooltipWrapper>
            <Button onClick={() => navigate('/login')}>
              <ButtonLabel>지금 시작</ButtonLabel>
            </Button>
            {showTooltip && (
              <TooltipBox>
                <TooltipContent>
                  <span>지금 가입하면 3일 무료체험!</span>
                  <img
                    src="/assets/images/close/close_blue.svg"
                    alt=""
                    onClick={() => setShowTooltip(false)}
                  />
                </TooltipContent>
              </TooltipBox>
            )}
          </TooltipWrapper>
        )}
      </Content>

      <Right>
        <IconButton onClick={() => navigate('/quick-search')}>
          <img src="/assets/images/icon/search-black.svg" alt="search" />
        </IconButton>
        <IconButton onClick={handleClickUserButton}>
          <img src="/assets/images/icon/user.svg" alt="mypage" />
        </IconButton>
      </Right>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 6px 6px 6px 16px;
  align-items: center;
  gap: 8px;

  position: sticky;
  top: 0;
  background: #f3f4f6;
  z-index: 1000;
`;

const Logo = styled.div`
  display: flex;
  height: 44px;
  align-items: center;
  gap: 10px;
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
`;

const Button = styled.button`
  border: none;
  outline: none;
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background: #e7f0fe;

  color: #008aff;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const IconButton = styled.div`
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;

  & > img {
    width: 24px;
    height: 24px;
  }
`;

const TicketButton = styled(Button)`
  background: #008aff;
  color: #fff;
`;

const ButtonLabel = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const TooltipBox = styled.div`
  position: absolute;
  /* top: 22px; */
  bottom: -43px;
  /* width: 172px; */
  aspect-ratio: 192 / 51;

  background: url('/assets/images/main/tooltip.svg') center / 100% 100%
    no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0 12px;
  z-index: 10;
`;

const TooltipContent = styled.div`
  display: flex;
  padding: 7px 8px 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  white-space: nowrap;

  color: #008aff;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const Span = styled.span`
  font-size: 13px;
  color: #008aff;
  font-weight: 700;
`;
const InputBox = styled.div<{ focus?: boolean }>`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0px 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: ${({ focus }) => (focus ? 'none' : '9999px')};
  border-top-left-radius: ${({ focus }) => (focus ? '10px' : '9999px')};
  border-top-right-radius: ${({ focus }) => (focus ? '10px' : '9999px')};
  border: ${({ focus }) => (focus ? 'solid 1px #b9b8b8' : 'solid 1px #b9b8b8')};
  background-color: #f7f8fc;
`;

const Input = styled.input`
  width: 100%;
  outline: none;
  border: none;
  background-color: transparent;
`;

const AutoComplete = styled.ul`
  min-width: 240px;
  width: 100%;
  position: absolute;
  top: 26px;
  z-index: 9999;
  background-color: #fff;
  border-left: solid 1px #b9b8b8;
  border-right: solid 1px #b9b8b8;
  border-bottom: solid 1px #b9b8b8;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  max-width: inherit;
  max-height: 400px;
  overflow-y: auto;

  li {
    width: 100%;
    padding: 10px;
    border-bottom: solid 1px #b9b8b8;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;

    &:hover {
      background-color: rgb(255, 254, 223);
    }

    &.no-hover {
      &:hover {
        background-color: transparent;
      }
    }

    div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    div > div:first-child {
      flex: 6;
    }

    div > div:nth-child(2) {
      flex: 4;
      justify-content: flex-end;
    }
  }

  :last-child {
    border-bottom: none;
  }
`;

const AutoCompleteText = styled.div<{ color?: string }>`
  display: inline-block;
  min-width: 0;
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.color};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const AuctionType = styled.div<{ type: string }>`
  justify-content: flex-end;
  padding: 2px 8px;
  border-radius: 999px;
  max-width: fit-content;
  font-size: 12px;
  background-color: ${(props) =>
    (props.type === 'a' && 'rgb(255, 219, 214)') ||
    (props.type === 'p' && 'rgb(222, 237, 255)') ||
    (props.type === 'e' && '#fffce3')};
  color: ${(props) =>
    (props.type === 'a' && 'rgb(216, 72, 54)') ||
    (props.type === 'p' && 'rgb(12, 100, 206)') ||
    (props.type === 'e' && '#d87300')};
  font-weight: 500;
`;

const StatusBadge = styled.div`
  justify-content: flex-end;
  padding: 2px 8px;
  border-radius: 999px;
  max-width: fit-content;
  font-size: 12px;
  background-color: #70737c14;
  color: #37383c9c;
  font-weight: 500;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 14px;
  cursor: pointer;
`;
